import { accentColors } from '@tryhackme/thm-ui-components';
import { ReactComponent as StarIcon } from 'src/images/svgs/reprofiling/stars.svg';
import styled from 'styled-components';
export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 52rem;
`;
export const StyledTopPanel = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  padding: 2.9rem 3.6rem;
  background: linear-gradient(-99deg, rgba(21, 28, 43, 0.40) -1.18%, rgba(15, 64, 91, 0.40) 33.04%, rgba(0, 108, 126, 0.40) 47.45%, rgba(0, 156, 139, 0.40) 69.26%, rgba(0, 154, 138, 0.40) 84.8%, rgba(0, 200, 119, 0.40) 99.87%), #1C2538;
  height: 32.1rem;
`;
export const StyledStarIcon = styled(StarIcon)`
  position: absolute;
  top: 0;
  left: 20%;
  width: 50%;
  height: 50%;
`;
export const StyledContentPanel = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 3.2rem;
  padding: 4rem;
  background: ${({
  theme
}) => theme.colors.background.main};
  min-height: 28rem;
  border-radius: ${({
  theme
}) => theme.radius.small};
`;
export const StyledMainContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3.2rem;
`;
export const StyledGreeting = styled.h2<{
  $isDarkMode: boolean;
}>`
  font-size: 2.4rem;
  font-weight: 400;
  color: ${({
  theme
}) => theme.colors.text};
  margin: 0;
  line-height: 1.08;

  span {
    color: ${({
  theme,
  $isDarkMode
}) => $isDarkMode ? theme.colors.primary.main : accentColors.success.light};
    font-weight: 600;
  }
`;
export const StyledMainTextSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;
export const StyledMainTextRow = styled.div`
  display: flex;
  gap: 0.8rem;
  align-items: center;

  svg {
    color: ${({
  theme
}) => theme.colors.primary};
  }
`;
export const StyledMainText = styled.span<{
  $isDarkMode: boolean;
}>`
  font-size: 4rem;
  font-weight: 600;
  color: ${({
  theme
}) => theme.colors.text};
  line-height: 1.19;

  > span {
    color: ${({
  theme,
  $isDarkMode
}) => $isDarkMode ? theme.colors.primary.main : accentColors.success.light};
  }
`;
export const StyledSubtext = styled.p`
  font-size: 2rem;
  color: ${({
  theme
}) => theme.colors.text};
  margin: 0;
  line-height: 2.6rem;
  font-weight: 400;
`;
export const StyledButton = styled.button`
  background: ${({
  theme
}) => theme.colors.primary.main};
  color: #151C2B;
  border: 1px solid ${({
  theme
}) => theme.colors.primary.main};
  border-radius: 0.4rem;
  padding: 1rem 1.6rem;
  font-size: 1.6rem;
  font-weight: 400;
  cursor: pointer;
  transition: background 0.2s;
  &:hover {
    background: #8fd41c;
  }
`;